import React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';
import { RemoveRedEye as EyeIcon } from '@mui/icons-material';
import DateUtils from 'js/lib/DateUtils';
import { bytesToString } from 'js/lib/FormatUtils';
import PreviewButton from 'js/components/destination/destination-content/database/PreviewButton';
import { CONNECTION_CATEGORY_FILE } from 'js/constants/connectionCategories';
import { Stack } from 'new/elements/Stack';
import { PROBE_GET_FILE_REQUEST } from 'js/constants/actionTypes';

class SelectBucketTreeViewNode extends React.Component {
  constructor(props) {
    super(props);
    this._handleNodePreview = this._handleNodePreview.bind(this);
  }

  _handleNodePreview(event) {
    event.stopPropagation();
    this.props.onNodePreview(this.props.node);
  }

  render() {
    const paddingLeft = 0; //this.props.level * 16;
    const selected = this.props.node.id === this.props.selectedNodeId;
    const iconElement =
      this.props.node.type === 'folder' ? (
        <div className="treeview-list-icon" />
      ) : this.props.node.mimeType ===
        // this logic is still here because we can update the icon later
        // if we want to use different icons for different file types
        'application/vnd.google-apps.spreadsheet' ? (
        <div className="treeview-list-file-icon" />
      ) : (
        <div className="treeview-list-file-icon" />
      );

    const className = classnames('treeview-list-item', 'treeview-list-content', {
      selected: selected,
    });
    const showPreviewButton = this.props.node.type !== 'folder';

    return (
      <div
        className={className}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: paddingLeft,
        }}
      >
        {iconElement}
        <div
          data-testid={`treeview-list-title-${this.props.node.displayName}`}
          className="treeview-list-title"
        >
          <div>{this.props.node.displayName}</div>
          {this.props.node.type === 'file' && (
            <div className="treeview-list-description">
              {!isNil(this.props.node.updatedAt) && (
                <span>
                  <b>Modified:</b>{' '}
                  {DateUtils.convertDateStringToFormat(
                    this.props.node.updatedAt,
                    'MMM D, YYYY',
                    true,
                    true,
                  )}{' '}
                  •{' '}
                </span>
              )}
              <b>Size: </b>
              {!isNil(this.props.node.size) ? bytesToString(this.props.node.size, '.1') : '0 B'}
            </div>
          )}
        </div>
        {showPreviewButton && (
          <Stack className="preview-samples" direction="row" justifyContent="flex-end">
            <PreviewButton onClick={this._handleNodePreview} requestKey={PROBE_GET_FILE_REQUEST} />
          </Stack>
        )}
      </div>
    );
  }
}

export default SelectBucketTreeViewNode;
